import { ORGANISATION_UPDATE_CHANNEL } from '@modules/organisation/actions';
import Api from '../../../common/services/api';


export default (orgId, channel) => async (dispatch) => {
  const { data } = await Api.post(`/v1/organisations/${orgId}/channels/${channel.id}/leave`);
  dispatch({ type: ORGANISATION_UPDATE_CHANNEL, channel });
  return data;
};
